import React, { Fragment, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Card,
  CardContent,
  Grid,
  ButtonBase
} from '@mui/material';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useHistory } from "react-router-dom"
import FrontSiteNavbar from './layout/FrontSiteNavbar';
import { get_data_value } from './helpers/untils';
import { useState } from 'react';
import { Stack } from '@mui/material';
import Lightbox from 'react-image-lightbox';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import { IMAGE_CACHE_VERSION } from './config/constant';

const data = {
  "MT3V": {
    "Price": "$165.00",
    "Monthly": "$15.00",
    "Tracking Interval": "30 Sec",
    "Toll Tracking": "y",
    "Unlimited Geofence": "y",
    "Speed Alert": "y",
    "Over Miles Alert": "y",
    "Possible Towing": "y",
    "Severe Weather": "y",
    "Late Return": "y",
    "Maintenance Tracking": "y",
    "Profit and Loss Tracking": "y",
    "Tint Insurance": "y",
    "ABI Insurance": "y",
    "KillSwitch": "y",
    "Lock": "y",
    "Unlock": "y",
    "Bluetooth Unlock": "y",
    "Renter Locate": "y",
    "Renter Lock and Unlock": "y",
    "Honk Horn": "y",
    "Flash Lights": "y",
    "Hood Open Detect": "y",
    "Door Open Detect": "y",
    "Auto Lock on Geofence": "y",
    "Auto Lock at end of Trip": "y",
    "Auto Killswitch on Lock": "y",
    "Walkaway Proximity locks/ Killswitch": "y",
    "Killswitch on device removal": "y",
    "Waterproof": ""
  },
  "KS": {
    "Price": "$40.00",
    "Monthly": "$12.50",
    "Tracking Interval": "1 Minute",
    "Toll Tracking": "y",
    "Unlimited Geofence": "y",
    "Speed Alert": "y",
    "Over Miles Alert": "y",
    "Possible Towing": "y",
    "Severe Weather": "y",
    "Late Return": "y",
    "Maintenance Tracking": "y",
    "Profit and Loss Tracking": "y",
    "Tint Insurance": "y",
    "ABI Insurance": "y",
    "KillSwitch": "y",
    "Lock": "",
    "Unlock": "",
    "Bluetooth Unlock": "",
    "Renter Locate": "y",
    "Renter Lock and Unlock": "",
    "Honk Horn": "",
    "Flash Lights": "",
    "Hood Open Detect": "",
    "Door Open Detect": "",
    "Auto Lock on Geofence": "",
    "Auto Lock at end of Trip": "",
    "Auto Killswitch on Lock": "",
    "Walkaway Proximity locks/ Killswitch": "",
    "Killswitch on device removal": "y",
    "Waterproof": ""
  },
  "WATER": {
    "Price": "$65.00",
    "Monthly": "$12.50",
    "Tracking Interval": "1 Minute",
    "Toll Tracking": "y",
    "Unlimited Geofence": "y",
    "Speed Alert": "y",
    "Over Miles Alert": "y",
    "Possible Towing": "y",
    "Severe Weather": "y",
    "Late Return": "y",
    "Maintenance Tracking": "y",
    "Profit and Loss Tracking": "y",
    "Tint Insurance": "y",
    "ABI Insurance": "y",
    "KillSwitch": "y",
    "Lock": "",
    "Unlock": "",
    "Bluetooth Unlock": "",
    "Renter Locate": "y",
    "Renter Lock and Unlock": "",
    "Honk Horn": "",
    "Flash Lights": "",
    "Hood Open Detect": "",
    "Door Open Detect": "",
    "Auto Lock on Geofence": "",
    "Auto Lock at end of Trip": "",
    "Auto Killswitch on Lock": "",
    "Walkaway Proximity locks/ Killswitch": "",
    "Killswitch on device removal": "",
    "Waterproof": "y"
  },
  "Tesla": {
    "Price": "$0.00",
    "Monthly": "$10.00",
    "Tracking Interval": "1 Minute",
    "Toll Tracking": "y",
    "Unlimited Geofence": "y",
    "Speed Alert": "y",
    "Over Miles Alert": "y",
    "Possible Towing": "y",
    "Severe Weather": "y",
    "Late Return": "y",
    "Maintenance Tracking": "y",
    "Profit and Loss Tracking": "y",
    "Tint Insurance": "y",
    "ABI Insurance": "y",
    "KillSwitch": "",
    "Lock": "y",
    "Unlock": "y",
    "Bluetooth Unlock": "",
    "Renter Locate": "",
    "Renter Lock and Unlock": "y",
    "Honk Horn": "y",
    "Flash Lights": "y",
    "Hood Open Detect": "",
    "Door Open Detect": "",
    "Auto Lock on Geofence": "",
    "Auto Lock at end of Trip": "",
    "Auto Killswitch on Lock": "",
    "Walkaway Proximity locks/ Killswitch": "",
    "Killswitch on device removal": "",
    "Waterproof": ""
  },
  "OEM": {
    "Price": "$0",
    "Monthly": "$10.00",
    "Tracking Interval": "30 Minute",
    "Toll Tracking": "",
    "Unlimited Geofence": "Limited",
    "Speed Alert": "",
    "Over Miles Alert": "y",
    "Possible Towing": "",
    "Severe Weather": "Limited",
    "Late Return": "",
    "Maintenance Tracking": "y",
    "Profit and Loss Tracking": "",
    "Tint Insurance": "",
    "ABI Insurance": "",
    "KillSwitch": "",
    "Lock": "y",
    "Unlock": "y",
    "Bluetooth Unlock": "",
    "Renter Locate": "Limited",
    "Renter Lock and Unlock": "y",
    "Honk Horn": "",
    "Flash Lights": "",
    "Hood Open Detect": "",
    "Door Open Detect": "",
    "Auto Lock on Geofence": "",
    "Auto Lock at end of Trip": "",
    "Auto Killswitch on Lock": "",
    "Walkaway Proximity locks/ Killswitch": "",
    "Killswitch on device removal": "",
    "Waterproof": ""
  }
}

const PricingSiteV3 = () => {
  const theme = useTheme();
  const history = useHistory()
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const tableType = false; //isTablet

  useEffect(() => {
    const script = document.createElement('script');
    script.src = "./assets/js/animation.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }
  }, []);

  const [appSetting, setAppSetting] = useState({});

  ///////////////////////////////////////////////////////////////////////////////////////////////////
  const headers = Array.from(new Set(Object.values(data).flatMap(item => Object.keys(item))));
  const products = Object.keys(data);

  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState('');
  const onClickDeviceType = (product) => {
    setCurrentImage(`/assets/img/pricing/${product}.jpg`)
    setImageModalOpen(true)
  }

  return (
    <React.Fragment>

      <FrontSiteNavbar
        setAppSetting={setAppSetting}
      />

      <main id="content" role="main">
        <div className="gradient-x-overlay-sm-primary position-relative overflow-hidden">
          <div className="container content-space-t-3 content-space-t-lg-4 content-space-b-1 content-space-b-md-2">
            <div className="text-center mx-lg-auto">
              <div className="">
                <h2 className="">
                  MooveTrax Product Comparison
                </h2>
              </div>
            </div>
          </div>
          <div className='bg-white overflow-hidden'>
            <div className="container content-space-1 content-space-md-2" style={{ fontSize: "1rem", wordBreak: 'break-word' }}>
              <div className='text-left mx-lg-auto'>
                <div className='row'>
                  <div className='col-md-12'>
                    <div className=" ">
                      {
                        (tableType) ? (
                          <>
                            <Grid container spacing={2}>
                              {products.map((pro2332duct) => (
                                <Grid item xs={12} key={product}>
                                  <Card variant="outlined">
                                    <CardContent>
                                      <Stack direction={`row`} spacing={1} justifyContent={`flex-start`} alignItems={`center`} style={{ marginBottom: '8px' }}>
                                        <ButtonBase disableRipple={true} onClick={() => onClickDeviceType(product)}>
                                          <Stack direction={`row`} spacing={1} justifyContent={`flex-start`} alignItems={`center`}>
                                            <Typography variant="h6" style={{ cursor: 'pointer' }} gutterBottom>
                                              {product}
                                            </Typography>
                                            <CameraAltIcon />
                                          </Stack>
                                        </ButtonBase>
                                      </Stack>
                                      <Stack direction={`column`} justifyContent={`flex-start`} alignItems={`flex-start`} spacing={1}>
                                        {headers.map((feature) => {
                                          const value = data[product][feature] || ''
                                          return (
                                            <Fragment key={feature}>
                                              <Typography variant="body2">
                                                <strong>{feature}: &nbsp;</strong>
                                                {
                                                  (value === 'y') ? (
                                                    <img src={`/assets/img/checkmark.png`} width={16} height="auto" />
                                                  ) : (
                                                    <>{value}</>
                                                  )
                                                }
                                              </Typography>
                                            </Fragment>
                                          )
                                        })}
                                      </Stack>
                                    </CardContent>
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                          </>
                        ) : (
                          <>
                            <TableContainer component={Paper} sx={{ maxHeight: '580px' }}>
                              <Table stickyHeader className="table table-lg table-striped table-borderless table-nowrap table-vertical-border-striped" size="small" aria-label="Comparison table" style={{ marginBottom: 0 }}>
                                <TableHead>
                                  <TableRow>
                                    <TableCell className="text-dark" style={{ background: '#ffffff' }}>Feature</TableCell>
                                    {products.map((product) => {
                                      return (
                                        <TableCell
                                          className="text-dark"
                                          key={product}
                                          style={{ cursor: 'pointer', background: '#ffffff' }}
                                          onClick={() => onClickDeviceType(product)}
                                        >
                                          <Stack direction={`row`} spacing={1} justifyContent={`flex-start`} alignItems={`center`}>
                                            <span>{product}</span>
                                            <CameraAltIcon />
                                          </Stack>
                                        </TableCell>
                                      )
                                    })}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {headers.map((feature) => {
                                    return (
                                      <TableRow key={feature}>
                                        <TableCell className="text-dark" component="th" scope="row">
                                          {feature}
                                        </TableCell>
                                        {products.map((product) => {
                                          const value = data[product][feature] || ''
                                          return (
                                            <TableCell className="text-dark" key={product + feature}>
                                              {
                                                (value === 'y') ? (
                                                  <img src={`/assets/img/checkmark.png`} width={20} height="auto" />
                                                ) : (
                                                  <>{value}</>
                                                )
                                              }
                                            </TableCell>
                                          )
                                        })}
                                      </TableRow>
                                    )
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </>
                        )
                      }
                    </div>
                  </div>
                </div>
              </div>

              <div className="shop-intro-box-1">
                <div className="shop-intro-box-inner">
                  <div className="row">
                    <div className="col-lg-6 mb-3 mb-lg-0 text-center">
                      <a className="shop-item" href={get_data_value(appSetting, 'SHOPPING_AMAZON_LINK')} aria-label="Amazon" target="_blank">
                        <img className="navbar-brand-logo" src="/assets/img/shop/amazon-shop.webp" alt="Amazon" />
                      </a>
                    </div>
                    <div className="col-lg-6 mb-3 mb-lg-0 text-center">
                      <a className="shop-item" href={get_data_value(appSetting, 'SHOPPING_CART_LINK')} aria-label="Shopify" target="_blank">
                        <img className="navbar-brand-logo" src="/assets/img/logo.png" alt="Shopify" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </main>
      <a className="js-go-to go-to position-fixed" href="javascript:;" style={{ visibility: 'hidden' }}
        data-hs-go-to-options='{
        "offsetTop": 700,
        "position": {
            "init": {
            "right": "2rem"
            },
            "show": {
            "bottom": "2rem"
            },
            "hide": {
            "bottom": "-2rem"
            }
        }
        }'>
        <i className="bi-chevron-up"></i>
      </a>

      <>
        {imageModalOpen && (
          <Lightbox
            mainSrc={`${currentImage}?v=${IMAGE_CACHE_VERSION}`}
            onCloseRequest={() => setImageModalOpen(false)}
          />
        )}
      </>

    </React.Fragment>
  );
};

export default PricingSiteV3;
